import axios from "axios";
import authHeader from "./authHeader";
import { apiPath, API_URL } from "./apiPath";
export const getWorkersList = (params) => {
  if (params.pagination != null && params != "") {
    return axios
      .post(params.pagination, params, authHeader())
      .then((response) => {
        return response.data;
      });
  } else {
    return axios
      .post(API_URL + apiPath.getWorkersList, params, authHeader())
      .then((response) => {
        return response.data;
      });
  }
};
export const getInviteWorkersListApi = (params) => {
  if (params.path) {
    return axios.post(params.path, {}, authHeader()).then((response) => {
      return response.data;
    });
  } else {
    return axios
      .post(API_URL + apiPath.getInviteWorkersList, params, authHeader())
      .then((response) => {
        return response.data;
      });
  }
};
export const getEmployerJobappliedWorkersListApi = (params) => {
  if (params.path) {
    return axios.post(params.path, {}, authHeader()).then((response) => {
      return response.data;
    });
  } else {
    return axios
      .post(
        API_URL + apiPath.getEmployerJobappliedWorkersList,
        params,
        authHeader()
      )
      .then((response) => {
        return response.data;
      });
  }
};
export const getWorkerJobsApi = (worker_id) => {
  return axios
    .post(API_URL + apiPath.getWorkerJobs, worker_id, authHeader())
    .then((response) => {
      return response.data;
    });
};
export const getWorkerInformaton = (worker_id) => {
  return axios
    .post(API_URL + apiPath.getWorkerInfo, { worker_id }, authHeader())
    .then((response) => {
      return response.data;
    });
};
